import { Button, Control } from "@allxsmith/bestax-bulma";
import React from "react";

function useInlineEditButton({
                               show,
                               onSave,
                               setEditable,
                               editable,
                               disabled
                             }) {
  if (show) {
    return (editable ? (<Control>
      <Button
        className="small-row-white"
        color="success"
        onClick={onSave}
      >
        S
      </Button>
    </Control>) : (<Control>
      <Button
        className="small-row-black"
        onClick={() => setEditable(!editable)}
        disabled={disabled}
      >
        E
      </Button>
    </Control>));
  }
  return null;
}

export default useInlineEditButton;
